export const menuListDiscente = [
  {
    title: 'Estender bolsa',
    icon: 'plus',
    link: '/discente/estender',
    color: 'red'
  },
  {
    title: 'Perfil',
    icon: 'profile',
    link: '/discente/profile',
    color: 'blue'
  }
]
